import store from 'owa-mail-store/lib/store/Store';
import { action, mutator } from 'satcheljs';

/**
 * Sets showListPane value in store to passed in value
 * @param showListPane Whether to show list view
 */
const setShowListPane = action('setShowListPane', function setShowListPane(showListPane: boolean) {
    return {
        showListPane,
    };
});

mutator(setShowListPane, actionMessage => {
    store.mailModule.showListPane = actionMessage.showListPane;
});
export default setShowListPane;
